import AvatarBuilderPanel from "./AvatarBuilderPanel";

export default function AdminAvatar() {
  return (
    <div className="rounded-xl border border-stone bg-paper p-6 md:p-8 shadow-sm">
      <AvatarBuilderPanel />
    </div>
  );
}
